import { Injectable } from '@angular/core';
import {Config} from '@app/entity';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ConfigService {

  DEFAULT_CONFIG: Config = {
    showFilterCity: false,
  };

  private _config: Config;

  private configStream = new ReplaySubject<Config>(1);
  config: Observable<Config> = this.configStream.asObservable();

  constructor() {
    this._config = this.DEFAULT_CONFIG;
    this.configStream.next(this._config);
  }

  setConfig(newConfig: Config) {
    this._config = newConfig;
    this.configStream.next(newConfig);
  }

  updateShowFilterCity(showFilterCity: boolean) {
    this.configStream.next({...this._config, showFilterCity: showFilterCity});
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/config.service.ts